import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './AboutUs.css';

const AboutUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    location: '',
    services: [],
    otherService: ''
  });

  const [showOtherInput, setShowOtherInput] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    const updatedServices = checked
      ? [...formData.services, value]
      : formData.services.filter((s) => s !== value);

    setFormData({ ...formData, services: updatedServices });

    if (value === 'Other') setShowOtherInput(checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, phone, email, location, services, otherService } = formData;

    // Validate name
    if (!name.trim()) {
      Swal.fire('Oops!', 'Name is required!', 'error');
      return;
    }

    // Validate phone (digits only, 10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      Swal.fire('Invalid Phone', 'Please enter a valid 10-digit phone number.', 'warning');
      return;
    }

    // Confirm submission with SweetAlert
    const result = await Swal.fire({
      title: 'Confirm Submission?',
      text: 'This will open WhatsApp with your details.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, continue',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      const serviceList = services.join(', ');
      const otherText = otherService ? `\nOther: ${otherService}` : '';
      const emailText = email ? `\nEmail: ${email}` : '';

      const message = `Name: ${name}
Phone: ${phone}${emailText}
Location: ${location}
Services: ${serviceList}${otherText}`;

      const encodedMessage = encodeURIComponent(message);
      const whatsappURL = `https://wa.me/918951089998?text=${encodedMessage}`; // replace with your number

      window.open(whatsappURL, '_blank');
    }
  };

  return (
    <div className="about-contact-page">
      {/* ABOUT SECTION */}
      <div className="about-us-section">
        <div className="about-container">
          <div className="about-images">
            <img src="/images/about1.jpg" alt="About1" />
            <img src="/images/about2.jpg" alt="About2" />
          </div>
          <div className="about-content">
            <h1>About Orange Home Interiors</h1>
            <p>
              Orange Home Interiors is your destination for transforming homes with creative and custom-made designs.
              With a focus on functionality and elegance, we deliver interior solutions that are tailored to your taste and lifestyle.
              Whether it’s a modular kitchen or a luxurious bedroom, our expert team ensures each space is aesthetically pleasing and practically perfect.
            </p>
          </div>
        </div>
      </div>

      {/* CONTACT US SECTION */}
      <div className="contact-us-section">
        <h2>Contact Us</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name*</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number*</label>
            <input
              type="tel"
              name="phone"
              required
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter 10 digit number"
              pattern="[0-9]{10}"
              maxLength="10"
            />
          </div>

          <div className="form-group">
            <label>Email ID (optional)</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Location*</label>
            <select
              name="location"
              required
              value={formData.location}
              onChange={handleChange}
            >
              <option value="">Select Location</option>
              <option value="Bengaluru">Bengaluru</option>
              <option value="Mysuru">Mysuru</option>
              <option value="Hubballi">Hubballi</option>
              <option value="Ballari">Ballari</option>
              <option value="Udupi">Udupi</option>
              <option value="Dharwad">Dharwad</option>
              <option value="Shivamogga">Shivamogga</option>
              <option value="Tumakuru">Tumakuru</option>
              <option value="Chikkamagaluru">Chikkamagaluru</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>What do you need? *</label>
            <div className="checkbox-grid">
              {[
                "Living Room", "Kitchen", "Dining Area", "Wardrobes", "Study Room",
                "Children Room", "Partitions", "Sofa", "Cot", "TV Unit", "Pooja Unit",
                "False Ceiling", "Lighting", "Painting", "Tiling", "Other"
              ].map((service, idx) => (
                <label key={idx}>
                  <input
                    type="checkbox"
                    value={service}
                    onChange={handleCheckboxChange}
                  />&nbsp;
                  {service}
                </label>
              ))}
            </div>
            {showOtherInput && (
              <input
                type="text"
                name="otherService"
                value={formData.otherService}
                onChange={handleChange}
                placeholder="Specify Other"
              />
            )}
          </div>

          <button type="submit" className="submit-button">Submit via WhatsApp</button>
        </form>
      </div>
    </div>
  );
};

export default AboutUs;
